import { capabilities } from 'navigation-components/capabilities';
import { useCapability } from 'navigation-components/platform/hooks';
import { useCallback, useEffect } from 'react';
import { addAlert } from '../../reducers/Alerts';
import { useAppDispatch } from '../index';
export const useAlerts = () => {
  const dispatch = useAppDispatch();
  const {
    subscribe: subscribeToAlerts
  } = useCapability(capabilities.ALERT_MESSAGE_CAP.getName());
  const handleAlerts = useCallback(({
    type,
    message,
    linkText,
    href,
    title
  }) => {
    const alertContentLink = linkText && href ? {
      text: linkText,
      href
    } : undefined;
    const addAlertAction = addAlert({
      type,
      content: {
        body: message,
        title,
        link: alertContentLink
      }
    });
    dispatch(addAlertAction);
  }, [dispatch]);
  useEffect(() => subscribeToAlerts(handleAlerts), [handleAlerts, subscribeToAlerts]);
};